import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-labs',
  templateUrl: './labs.component.html',
  styleUrls: ['./labs.component.scss']
})
export class LabsComponent implements OnInit {
  imgUrl=[
    '/assets/img/physics/1.jpeg',
    '/assets/img/physics/2.jpeg',
    '/assets/img/physics/3.jpeg',
    '/assets/img/physics/4.jpeg',
    '/assets/img/physics/5.jpg',
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
